import React from 'react'
import Styles from "./UserPage.module.css"
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import DateUtilities from '../../componentes/DateUtilities'

class Pendientes extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ListActivities: [],
            employee:this.props.userName,
            tablaHidden : false,
            mensajeHidden : true,
        }
    }
    componentDidMount() {
        this.getData()
    }
    componentWillUnmount() {
        clearInterval(this.interval)
    }
    getData = async () => {
        try {
            const snapShot = await firebase.firestore().collection('TareasAsignadas').where('estado', '==', 'pendiente').get()
            const ListActivities = []
            for (let i = 0; i < snapShot.docs.length; i++) {
                if (!snapShot.docs[i].exists) break
                const activity = snapShot.docs[i]
                const usuario = this.state.employee;
                const listaTrabajadores = activity.data().empleados;
                const isInArray = listaTrabajadores.indexOf(usuario) > -1;
                if (isInArray === true){
                    ListActivities.push({
                        name: activity.data().empleados,
                        activity: activity.data().nombreActividad,
                        days: DateUtilities.GetDayDifference(activity.data().fechaEntrega.toDate(), DateUtilities.today()),
                        description: activity.data().descripcion,
                        sector: activity.data().areaAsignada,
                    })
                }
            }
            this.setState({
                ListActivities: ListActivities,
            })
            if(ListActivities.length === 0){
                this.setState({
                    tablaHidden: true,
                    mensajeHidden: false
                })
            } else {
                this.setState({
                    tablaHidden: false,
                    mensajeHidden: true
                })
            }
        }
        catch (e) {
            console.log(e.message)
            if (e.message === 'Failed to get document because the client is offline.') {
                return this.getData()
            }
        }
    }
    render() {
        return (
            <>
                <div className={`${Styles.container}`}>
                    <header>
                        <h1>Actividades Pendientes</h1>
                    </header>
                    <h2 hidden={this.state.mensajeHidden}>No hay actividades pendientes, favor de contactar con el encargado.</h2>
                    <table hidden={this.state.tablaHidden} className={`${Styles.table}`}>
                        <tbody>
                            <tr className={`${Styles.header}`}>
                                <th>Actividad</th>
                                <th>Días</th>
                                <th>Descripción</th>
                                <th>Sector/Tunel-Surco</th>
                            </tr>
                            {
                                this.state.ListActivities.map((item, i) => (

                                    <tr key={i} className={`${Styles.row}`}>
                                        <td>{item.activity}</td>
                                        <td>{item.days}</td>
                                        <td>{item.description}</td>
                                        <td>{item.sector}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </>
        )
    }
}

export default Pendientes